import { Observable, of } from 'rxjs';
import { concatMap, map, switchMap } from 'rxjs/operators';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Trade } from 'src/app/components/trades/trades.model';
import { TradesService } from 'src/app/services/trades.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MarketType } from '../bids-and-offers/lots.model';
import { Store } from '@ngrx/store';
import { TableDataState } from 'src/app/store/table-data/table-data.reducer';
import { SeoService } from 'src/app/services/seo.service';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { LogEventsEnum } from 'src/app/firebase.model';
import { TradesItemLaptopDesktopComponent } from './trades-item-laptop-desktop/trades-item-laptop-desktop.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TradesItemComponent } from './trades-item/trades-item.component';
import { selectTableData } from 'src/app/store/table-data/table-data.selectors';

@Component({
  selector: 'app-trades',
  templateUrl: './trades.component.html',
  styleUrls: ['./trades.component.css'],
  imports: [
    TradesItemLaptopDesktopComponent,
    TradesItemComponent,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
})
export class TradesComponent implements OnInit, OnDestroy {
  private analytics = inject(Analytics);
  private tradesService = inject(TradesService);
  private breakpointObserver = inject(BreakpointObserver);
  private store = inject(Store<{ lotTableData: TableDataState }>);
  private seoService = inject(SeoService);
  trades$: Observable<Trade[]>;
  marketType$: Observable<MarketType>;
  isLoading: boolean;
  limit: number = 40;
  isWideScreen: boolean = false;

  constructor() {}
  ngOnInit() {
    logEvent(this.analytics, LogEventsEnum.trades_list_view);
    this.seoService.updateMetaTags([
      { name: 'description', content: 'List of Past Trades' },
      { name: 'author', content: "Johnston's Connected" },
      { name: 'keywords', content: 'Recently Traded' },
    ]);
    this.seoService.updateTitle('Trades Page');

    this.breakpointObserver
      .observe([
        '(max-width: 920px)', //(max-width: 599.98px)
        // Breakpoints.HandsetPortrait, // Mobile devices (max-width: 599.98px portrait)   (max-width: 959.98px) and (orientation: landscape)
      ])
      .subscribe((result) => {
        // this.isWideScreen = !result.matches;
        // console.log(result);
        // console.log('is handset', this.breakpointObserver.isMatched(Breakpoints.WebPortrait))
        if (this.breakpointObserver.isMatched('(max-width: 920px)')) {
          this.isWideScreen = false;
        } else {
          this.isWideScreen = true;
        }
      });
    this.isLoading = true;
    this.trades$ = this.store.select(selectTableData).pipe(
      map((res) => {
        // console.log('TRADES PARENT state', res);
        return res.selectedMarket;
      }),
      switchMap((marketType) => {
        return this.tradesService
          .watch(
            { market: MarketType[marketType] },
            {
              fetchPolicy: 'cache-and-network',
            }
          )
          .valueChanges.pipe(
            map((res) => {
              this.isLoading = false;
              // console.log(
              //   'INNER MAP()',
              //   MarketType[marketType],
              //   res.data.trades
              // );
              return res.data.trades;
            })
          );
      })
    );
    // this.trades$ = this.tradesService
    //   .watch({ limit: this.limit, market_type: this.marketType$ })
    //   .valueChanges.pipe(
    //     map((res) => {
    //       this.isLoading = false;
    //       return res.data.trades;
    //     })
    //   );
  }

  ngOnDestroy(): void {
    // this.trades$.unsubscribe()
  }
}
